import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-9349" data-mp="6gefv0t1lpyd">
      <PaymentForm data-id="element-9350" data-mp="6gxplu8jh81b" />
    </div>;
}